<template>
  <div class="item-box" @click="onClickItemBox">
    <a :href="linkUrl">
      <div class="item-card">
        <div class="item-card-icon">
          <ImgLazy
            :image-url="imageUrl"
            :alt-text="itemName"
            aspect-ratio="1 / 1"
          />
        </div>
        <div class="item-card-info">
          <LabelChips :labels="labels" />
          <div class="item-card__brand-name">
            {{ brandName }}
          </div>
          <div class="item-card__item-name">
            {{ itemName }}
          </div>
          <div class="item-card__item-prices">
            <span class="item-card__currency-symbol">¥</span>
            <span class="item-card__item-price">{{ itemPrice }}</span>
            <span v-if="isIncludingTax" class="item-card__item-tax">税込</span>
            <span v-if="hasMultipleItemSkus" class="item-card__item-skus">
              {{ priceSuffix }}
            </span>
            <span v-if="soldOut" class="item-card__sold-out"> 入荷待ち </span>
          </div>
        </div>
      </div>
    </a>
  </div>
</template>
<script>
import ImgLazy from '../images/ImgLazy.vue'
import LabelChips from '../labels/LabelChips.vue'

export default {
  components: {
    ImgLazy,
    LabelChips
  },
  props: {
    linkUrl: {
      type: String,
      required: true
    },
    imageUrl: {
      type: String,
      required: true
    },
    brandName: {
      type: String,
      required: true
    },
    itemName: {
      type: String,
      required: true
    },
    itemPrice: {
      type: String,
      required: true
    },
    isIncludingTax: {
      type: Boolean,
      required: true
    },
    hasMultipleItemSkus: {
      type: Boolean,
      required: true
    },
    priceSuffix: {
      type: String,
      default: '~'
    },
    soldOut: {
      type: Boolean,
      required: false,
      default: false
    },
    labels: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  methods: {
    onClickItemBox() {
      this.$emit('click-item-box')
    }
  }
}
</script>
<style lang="scss" scoped>
.item-box {
  width: 160px;
  flex-shrink: 0;
}

.item-card {
  @extend %hover-common;
  background-color: $white;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  text-decoration: none;
  border: 1px solid $gray-2;
  box-sizing: border-box;
  height: 100%;
}

.item-card-icon {
  // NOTE: inline-block 要素間の空白や改行などにあたる暗黙的なスタイルを回避するための対応
  font-size: 0;
}

.item-card-info {
  display: flex;
  padding: 16px 8px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  background-color: $white;
}

.item-card__brand-name {
  color: $gray-1;
  font-size: 1.2rem;
  line-height: 1.6;
  padding: 0;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.item-card__item-name {
  color: $black;
  white-space: normal;
  overflow-wrap: break-word;
  line-height: 1.6;
  font-size: 1.2rem;
  max-height: 3.84rem; // 1.2 * 2(行) * 1.6(line-height)
  font-weight: bold;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
}

.item-card__item-prices {
  padding-top: 0;
  display: flex;
  align-items: baseline;
  height: 22px;
}

.item-card__currency-symbol {
  font-weight: normal;
  font-size: 1rem;
  line-height: 1.6;
  color: $black;
}

.item-card__item-price {
  font-weight: normal;
  font-size: 1.4rem;
  line-height: 1.6;
  color: $black;
}

.item-card__item-tax {
  line-height: 1.6;
  font-size: 1rem;
  color: $black;
  margin-left: 2px;
}

.item-card__item-skus {
  line-height: 1.6;
  font-size: 1rem;
  color: $black;
  margin-left: 1px;
}

.item-card__sold-out {
  font-weight: bold;
  font-size: 1rem;
  line-height: 1.6;
  color: $gray-1;
  margin-left: 4px;
}
</style>
